<template>
  <div class="Box">
    <Header></Header>
    <div class="Content">
      <div class="HeaderText">Cookie政策</div>
      <div>
        本网站归属施乐辉医用产品国际贸易（上海）有限公司（以下简称“施乐辉”或“我们”）。
      </div>
      <div class="top30 Text1">什么是Cookies？</div>
      <div class="top30 Text2">
        <div>
          是当您浏览网站时由网站传输到您的计算机的小型文本文件。Cookie文件不能作为代码执行，不会传送病毒，也不会让我们访问您的硬盘。
        </div>
        <div>
          我们使用的“会话”cookie存储在内存中，只在您访问我们网站时存在，“持久性”cookie在过期前则存储在您的设备中，因此，当您再次访问我们的网站时将被继续使用。所有持久性
          cookie 都有一个 “生存期”, 它决定了 cookie 在您的设备上保持活动的时间。
        </div>
        <div>我们使用的Cookies不包含任何可以识别您私人身份的信息。</div>
      </div>

      <div class="top30 Text1">我们为什么使用cookies?</div>

      <div class="top30 Text2">
        利用cookie改善访问者访问我们网站的体验，cookie对于我们网站的运行必不可少，如果您在浏览我们网站时不想收到cookie，可以更改浏览器和/或移动设备的设置，以在收到cookie时获得通知，您还可以选择限制或阻止cookie。请注意，如果您禁用cookie，我们网站上的部分功能可能无法正常使用。
      </div>

      <div class="top30 Text1">管理Cookies</div>

      <div class="top30 Text2">
        <div>
          浏览器允许您在设备上控制Cookie的使用。如果你希望删除设备上现有的cookie和其他存储的数据也是可以的。
        </div>
        <div class="top20 Text2">
          <a
            href="https://support.google.com/accounts/answer/61416?hl=en"
            style="color: #72ace3"
            >谷歌Chrome游览器设置指南</a
          >
          <a
            href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer"
            style="color: #72ace3"
            >FireFox游览器设置指南</a
          >
          <a
            href="http://windows.microsoft.com/en-gb/internet-explorer/delete-manage-cookies"
            style="color: #72ace3"
            >微软Internet Explorer游览器设置指南</a
          >
          <a
            href="https://privacy.microsoft.com/zh-cn/windows-10-microsoft-edge-and-privacy"
            style="color: #72ace3"
            >围栏Edge游览器设置指南</a
          >
        </div>
      </div>

      <div class="top30 Text1">必要的Cookies</div>

      <div class="top30 Text2">
        <div>
          这些功能都是保证我们网站运行的必要功能。
          如果您禁用Cookies则将无法使用这些功能
        </div>
      </div>

      <div class="top30 Text1">分析和第三方Cookies</div>

      <div class="top30 Text2">
        <div>我们不用做分析和使用第三方Cookis。</div>
        <!-- <div>
          如果您有任何问题，请通过以下方式联系我们：Eshihui.CN@smith-nephew.com
        </div> -->
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "../components/FooterNav.vue";
import Header from "../components/HeaderNav.vue";
export default {
  components: {
    Footer,
    Header,
  },
  data() {
    return {};
  },
  methods: {},
  created() {
    window.scroll(0, 0);
  },
};
</script>

<style scoped="scoped">
.Box {
}

.Content {
  width: 60%;
  padding: 20px 0px;
  margin: auto;
  /* height: 80vh; */
}

.HeaderText {
  font-size: 25px;
  text-align: center;
}

.Text1 {
  font-size: 15px;
  font-weight: bold;
}

.Text2 {
  font-size: 15px;
}

.top30 {
  margin-top: 30px;
}

.top20 {
  margin-top: 20px;
}

a {
  text-decoration: none;
  display: block;
  margin-top: 5px;
}

a:active {
  color: #72ace3;
}
</style>
